/* unplugin-vue-components disabled */import { render } from "./WorkDetail.vue?vue&type=template&id=eb24a0bc&scoped=true&ts=true"
import script from "./WorkDetail.vue?vue&type=script&lang=ts"
export * from "./WorkDetail.vue?vue&type=script&lang=ts"

import "./WorkDetail.vue?vue&type=style&index=0&id=eb24a0bc&lang=less&scoped=true"
import "./WorkDetail.vue?vue&type=style&index=1&id=eb24a0bc&lang=less"

import exportComponent from "/project/node_modules/.pnpm/vue-loader@16.7.0_@vue+compiler-sfc@3.2.23_vue@3.2.23_webpack@4.46.0/node_modules/vue-loader/dist/exportHelper.js"
export default /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eb24a0bc"]])